import PropTypes from 'prop-types'

/**
 * Returns the parent path of a given path in the ingredients tree.
 *
 * @param {string} path - The path of the node in the ingredients tree.
 * @returns {string|null} - The parent path of the node, or null if the node is the root or has only one level.
 */
const getParentPath = (path) => {
  // Example path: ingredientsTree/animal/children/meat/children/chicken
  // Result: ingredientsTree/animal/children/meat

  if (!path) return null

  // Check if path has more than one level deep
  const isRoot = !path.includes('/children/')

  if (isRoot) {
    // If path points to the root node or has only one level, return null
    return null
  } else {
    // In other case, remove the last segment of the path
    const segments = path.split('/')
    segments.pop() // Remove the last segment (node name)
    segments.pop() // Remove the last segment (children)
    return segments.join('/')
  }
}

getParentPath.propTypes = {
  path: PropTypes.string
}

export default getParentPath
